import { render, staticRenderFns } from "./challenge_answer.vue?vue&type=template&id=0d087e65&scoped=true&"
import script from "./challenge_answer.vue?vue&type=script&lang=js&"
export * from "./challenge_answer.vue?vue&type=script&lang=js&"
import style0 from "./challenge_answer.vue?vue&type=style&index=0&id=0d087e65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d087e65",
  null
  
)

export default component.exports